import mutations from './otherExaminationDocumentType.mutations'
import actions from './otherExaminationDocumentType.actions'
import getters from './otherExaminationDocumentType.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
